import React, { useEffect, useState } from "react";
import { MasterHeading } from "../../../utils/helperData";
// import Vector from "../../../../asesst/Vector.svg";
// import { MdOutlineDelete } from "react-icons/md";
import { IoIosSearch } from "react-icons/io";
import { CgAddR } from "react-icons/cg";
// import { Box, Modal } from "@mui/material";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  GetWeldingMaster,
  deleteWelderMaster,
  editWelderMaster,
} from "../../../../redux/action/Master/MasterAction";
import { ADD_WELDING_MASTER } from "../../../utils/RouteConstant";
import Pagination from "../../../customComponent/Pagination";
import MasterTable from "../MasterTable/MasterTable";
import DeleteConfirmationModal from "../MasterTable/DeleteConfirmModal";

const WeldingMaster = () => {
  const [editRowId, setEditRowId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteRowId, setDeleteRowId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [editedData, setEditedData] = useState({
    name: "",
    status: 1,
    master_id: "",
    sequence: "",
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { masterdata, error } = useSelector((state) => state.master);

  useEffect(() => {
    dispatch(GetWeldingMaster());
    // const refreshInterval = setTimeout(() => {
    //   dispatch(GetWeldingMaster());
    // }, 1);
    // return () => clearInterval(refreshInterval);
  }, [dispatch]);

  const handleEditDetails = (item) => {
    setEditRowId(item._id);
    setEditedData({
      name: item.name,
      status: item.status,
      master_id: item._id,
      sequence: item?.sequence,
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSaveChanges = async () => {
    try {
      await dispatch(editWelderMaster(editedData));
      setEditRowId(null);
      dispatch(GetWeldingMaster());
    } catch (error) {
      console.error("Error saving changes:", error);
    }
  };

  const handleDeleteClick = (id) => {
    setShowDeleteModal(true);
    setDeleteRowId(id);
  };

  const handleDeleteConfirm = async () => {
    const result = await dispatch(deleteWelderMaster(deleteRowId));
    if (result.success) {
      setShowDeleteModal(false);
      dispatch(GetWeldingMaster());
    } else {
      console.error("Error deleting description:", error);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setDeleteRowId(null);
  };

  const handleAddWelder = () => {
    navigate(ADD_WELDING_MASTER);
  };

  const filteredData = masterdata?.list?.filter((item) =>
    // item.name.toLowerCase().includes(searchQuery.toLowerCase())
    item?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );

  const [currentPage, setCurrentPage] = useState(1);
  // const itemsPerPage = 10;
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const rowsPerPageOptions = [10, 20, 50, 100, "All"];

  const indexOfLastItem = currentPage * rowsPerPage;
  const indexOfFirstItem = indexOfLastItem - rowsPerPage;
  const currentItems = filteredData?.slice(indexOfFirstItem, indexOfLastItem);
  // const totalPages = Math.ceil(filteredData?.length / rowsPerPage);

  const totalCount = filteredData?.length;
  const totalPages =
    rowsPerPage === "All" ? 1 : Math.ceil(totalCount / rowsPerPage);

  const handleRowsPerPageChange = (event) => {
    const value = event.target.value;
    if (value === "All") {
      setRowsPerPage(totalCount);
      setCurrentPage(1);
    } else {
      setRowsPerPage(Number(value));
      setCurrentPage(1);
    }
  };
  return (
    <div className="p-4">
      <h2 className="text-3xl font-bold mb-6">Weld Additional Info</h2>
      <div className="flex flex-col sm:flex-row justify-between items-center mb-6 space-y-4 sm:space-y-0 sm:space-x-4">
        <div className="relative w-full sm:w-64 flex-grow sm:flex-grow-0">
          <input
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full lg:w-[400px] pl-10 pr-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
          <IoIosSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
        </div>
        <button
          onClick={handleAddWelder}
          className="w-full sm:w-auto bg-[#1C3664] text-white px-4 py-2 rounded-lg flex items-center justify-center hover:bg-blue-900 transition-colors"
        >
          <CgAddR className="mr-2" />
          Add New Welding Info
        </button>
      </div>
      {/* <div className="bg-white rounded-2xl shadow-sm p-4 sm:p-6">
        <div className="overflow-x-auto lg:max-h-[600px] max-h-96">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="sticky top-0 bg-[#F1F4F9]">
              <tr>
                {MasterHeading.map((head) => (
                  <th
                    key={head.name}
                    scope="col"
                    className="px-6 py-3 text-left text-base font-medium text-[#202224] uppercase tracking-wider"
                  >
                    {head.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {currentItems?.map((item, index) => (
                <tr key={item?._id}>
                  <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-500">
                    {indexOfFirstItem + index + 1}
                  </td>

                  <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-900">
                    {editRowId === item?._id ? (
                      <input
                        type="text"
                        name="name"
                        value={editedData.name}
                        onChange={handleInputChange}
                        className="border border-gray-300 rounded-lg px-2 py-1 w-full"
                      />
                    ) : (
                      item?.name
                    )}
                  </td>

                  <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-500">
                    {editRowId === item?._id ? (
                      <input
                        type="text"
                        name="sequence"
                        value={editedData.sequence}
                        onChange={handleInputChange}
                        className="border border-gray-300 rounded-lg px-2 py-1 w-full"
                      />
                    ) : (
                      <p>{item?.sequence || "-"}</p>
                    )}
                  </td>

                  <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-900">
                    {editRowId === item?._id ? (
                      <select
                        name="status"
                        value={editedData.status}
                        onChange={handleInputChange}
                        className="border border-gray-300 rounded-lg px-2 py-1 w-full"
                      >
                        <option value={1}>Active</option>
                        <option value={2}>Inactive</option>
                      </select>
                    ) : (
                      <span
                        className={`px-4 py-1 w-[70px] inline-flex text-xs leading-5 font-base rounded-full ${
                          item?.status === 1
                            ? "bg-[#467FE4] text-[#FFFFFF]"
                            : "bg-[#FB8787] text-[#FFFFFF]"
                        }`}
                      >
                        {item?.status === 1 ? "Active" : "Inactive"}
                      </span>
                    )}
                  </td>

                  <td className="px-6 py-3 whitespace-nowrap text-sm">
                    {editRowId === item?._id ? (
                      <button
                        onClick={handleSaveChanges}
                        className="bg-[#1C3664] text-white px-4 py-2 rounded-lg"
                      >
                        Save Changes
                      </button>
                    ) : (
                      <div className="flex items-center">
                        <span
                          onClick={() => handleEditDetails(item)}
                          className="text-[#1C3664] text-base font-poppins flex items-center cursor-pointer mr-4"
                        >
                          <img
                            src={Vector}
                            alt="edit details"
                            className="mr-1"
                          />
                        </span>
                        <span
                          onClick={() => handleDeleteClick(item?._id)}
                          className="text-red-600 text-base font-poppins flex items-center cursor-pointer"
                        >
                          <MdOutlineDelete size={24} />
                        </span>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div> */}
      <MasterTable
        MasterHeading={MasterHeading}
        currentItems={currentItems}
        indexOfFirstItem={indexOfFirstItem}
        editRowId={editRowId}
        editedData={editedData}
        handleInputChange={handleInputChange}
        handleSaveChanges={handleSaveChanges}
        handleEditDetails={handleEditDetails}
        handleDeleteClick={handleDeleteClick}
      />

      <DeleteConfirmationModal
        open={showDeleteModal}
        title="Confirm Deletion"
        message="Are you sure you want to remove this Weld Additional Info Master?"
        onConfirm={handleDeleteConfirm}
        onCancel={handleDeleteCancel}
        error={error}
      />
      {/* <Modal
        open={showDeleteModal}
        className="flex items-center justify-center"
      >
        <Box className="bg-white text-center p-4 rounded-2xl shadow-md w-[90%] max-w-md mx-auto">
          <h2 className="text-xl font-bold mb-4">Confirm Deletion</h2>
          <p className="mb-6">
            Are you sure you want to remove this Weld Additional Info?
          </p>
          <div className="flex justify-center space-x-4">
            <button
              onClick={handleDeleteConfirm}
              className="bg-red-500 text-white px-4 py-2 rounded-lg"
            >
              Yes, Remove
            </button>
            <button
              onClick={handleDeleteCancel}
              className="bg-gray-300 text-gray-700 px-4 py-2 rounded-lg"
            >
              Cancel
            </button>
          </div>
        </Box>
      </Modal> */}

      {/* {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      )} */}
      <div className="flex items-center justify-end mb-4 space-x-3">
        <div className="flex items-center mt-6 ">
          <label htmlFor="rows-per-page" className="mr-2">
            Rows per page:
          </label>
          <select
            id="rows-per-page"
            value={rowsPerPage}
            onChange={handleRowsPerPageChange}
            className="border border-solid border-2 h-[34px] rounded p-1 text-gray-500"
          >
            {rowsPerPageOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>

        {totalPages > 1 && rowsPerPage !== "All" && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        )}
      </div>
    </div>
  );
};

export default WeldingMaster;
